import React from 'react';

interface WabisabiIconProps {
  className?: string;
  size?: number;
}

export const WabisabiIcon: React.FC<WabisabiIconProps> = ({ 
  className = '', 
  size = 36 
}) => {
  return (
    <img 
      src="/wabisabi-logo-transparent.png" 
      alt="Wabisabi" 
      className={`${className}`}
      style={{ width: size, height: size }}
    />
  );
};